import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../store"

export enum ModalTypes {
  FORGOT_PASSWORD_MODAL = "FORGOT_PASSWORD_MODAL",
  CHANGE_PASSWORD_MODAL = "CHANGE_PASSWORD_MODAL",
  CHANGE_PIN_CODE_MODAL = "CHANGE_PIN_CODE_MODAL",
  VERIFY_PHONE_MODAL = "VERIFY_PHONE_MODAL",
  ADD_DRIVER_MODAL = "ADD_DRIVER_MODAL",
  ADD_DRIVER_DETAILS_MODAL = "ADD_DRIVER_DETAILS_MODAL",
  ADD_CARD_MODAL = "ADD_CARD_MODAL",
  SIMPLE_MODAL = "SIMPLE_MODAL",
  DISCONNECT_MODAL = "DISCONNECT_MODAL",
}
type ModalState = {
  activeModal: ModalTypes | null
  secondaryModal: ModalTypes | null
  data?: any
}

const initialState: ModalState = {
  activeModal: null,
  secondaryModal: null,
  data: null,
}
type OpenModalData = {
  activeModal: ModalTypes
  data?: any
}
type OpenSecondaryModalData = {
  secondaryModal: ModalTypes
  data?: any
}
export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    showModal: (state, action: PayloadAction<OpenModalData>) => {

      state.activeModal = action.payload.activeModal
      if (action.payload.data) state.data = action.payload.data
    },
    showSecondaryModal: (
      state,
      action: PayloadAction<OpenSecondaryModalData>,
    ) => {
      state.activeModal = action.payload.secondaryModal
      if (action.payload.data) state.data = action.payload.data
    },
    hideModal: (state) => {
      state.activeModal = null
      state.data = null
    },
    hideSecondaryModal: (state) => {
      state.secondaryModal = null
      state.data = null
      // TODO LOW need to manage secondary modal data. also inside SimpleModal
    },
  },
})

export const { showModal, showSecondaryModal, hideModal } = modalSlice.actions
export const selectActiveModal = (state: RootState) => state.modal.activeModal
export const selectSecondaryModal = (state: RootState) =>
  state.modal.secondaryModal
export const selectModalData = (state: RootState) => state.modal.data

export default modalSlice.reducer
